// extracted by mini-css-extract-plugin
export default {"titleStrict":"CheckboxField_titleStrict__SR65o"};